import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { SanitizedMessagePipe } from '@zero/shared/ui-pipes';
import { UserMessagesHolderService } from '@zero/shared/util-web-app-services';

@Component({
  selector: 'web-components-user-messages',
  templateUrl: './user-messages.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, NgbAlertModule, AsyncPipe, SanitizedMessagePipe],
})
export class UserMessagesComponent {
  public readonly msgService = inject(UserMessagesHolderService);

  @Input() public showLatestOnly = false;
}
